import React from 'react'

type viewButtonProps = {
  handleToggleFilter: React.MouseEventHandler<HTMLButtonElement>
}

const ViewMapButton = ({ handleToggleFilter }: viewButtonProps) => (
  <button
    className="nsw-button nsw-button--flex nsw-button--dark sopa-map--panel_view-map"
    data-toggle="map"
    type="button"
    onClick={handleToggleFilter}
  ><span className="nsw-material-icon material-icons">map</span><span>View Map</span></button>
)

export default ViewMapButton
